import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function tanquesfisicos(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@tanquesfisicos/FIND_TANQUEFISICO':
      case '@tanquesfisicos/UPDATE_TANQUEFISICO':
      case '@tanquesfisicos/DELETE_TANQUEFISICO':
      case '@tanquesfisicos/STORE_TANQUEFISICO':
      case '@tanquesfisicos/TANQUESFISICOS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@tanquesfisicos/SUCCESS_REMOVE':
      case '@tanquesfisicos/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@tanquesfisicos/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.tanquesfisicos;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@tanquesfisicos/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.tanquefisico;
        break;
      }

      case '@tanquesfisicos/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
